module.exports = __webpack_public_path__ + "static/img/img02.bcd0bc3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv022/img02.gif
// module id = rAKz
// module chunks = 0